
import React, { useEffect, useState } from 'react';
import './vidio.css';
import styles from '../../compoments/layout/footer/footer.module.css';
import logo from '../../images/logo.png'
import vid from '../../images/video_images/vid.jpg'
import axios from 'axios';
import AOS from 'aos';
import 'aos/dist/aos.css';
import fb from '../../images/fb.png'
import ig from '../../images/ig.png'
import youtube from '../../images/you.png'
import InfiniteScroll from 'react-infinite-scroll-component';
import videoStyle from 'pages/Video/video.module.css'

function Video() {
    // No need to import React again here if already imported above

const VideoItem = ({ item }) => {
    const [showIframe, setShowIframe] = React.useState(false);
    const videoId = item.snippet.resourceId?.videoId || item.id.videoId || item.id;
  
    return (
        <div className="video-item">
          <div
            className="drope-image"
            onClick={() => setShowIframe(true)} // Show iframe and autoplay the video
            style={{ cursor: 'pointer', position: 'relative' }}
          >
            {showIframe ? (
              <iframe
                width="100%"
                height="315"
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1`} // Autoplay enabled
                title="YouTube video player"
                frameBorder="0"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            ) : (
              <img
                src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                alt={item.snippet.title}
                className="img-fluid rounded"
                loading="lazy"
              />
            )}
    
            {/* YouTube Icon only visible if iframe is not shown */}
            {!showIframe && (
              <div className="youtube-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 256 180">
                  <path fill="#f00" d="M250.346 28.075A32.18 32.18 0 0 0 227.69 5.418C207.824 0 127.87 0 127.87 0S47.912.164 28.046 5.582A32.18 32.18 0 0 0 5.39 28.24c-6.009 35.298-8.34 89.084.165 122.97a32.18 32.18 0 0 0 22.656 22.657c19.866 5.418 99.822 5.418 99.822 5.418s79.955 0 99.82-5.418a32.18 32.18 0 0 0 22.657-22.657c6.338-35.348 8.291-89.1-.164-123.134"/>
                  <path fill="#fff" d="m102.421 128.06l66.328-38.418l-66.328-38.418z"/>
                </svg>
              </div>
            )}
          </div>
          <div className="drope-text vidio-custom">
            <h3>{item.snippet.title}</h3>
          </div>
        </div>
      );
    };
  
    const [loading, setLoading] = useState(true);

    const [videos, setVideos] = useState([]);
    const [shorts, setShorts] = useState([]);
    const [playlists, setPlaylists] = useState([]);
    const [activeTab, setActiveTab] = useState('home');
    const [videoPageToken, setVideoPageToken] = useState(null);  // To handle pagination for videos
    const [shortsPageToken, setShortsPageToken] = useState(null); // To handle pagination for shorts

    const API_KEY = 'AIzaSyDbCHy7ggFzp8dk7E6gI3MMID12rXyfe0Q';
    const CHANNEL_ID = 'UCziUYu9aahvyE251nJHwhMg';

    useEffect(() => {
        AOS.init({ duration: 1500, easing: 'ease-in-out' });
        fetchVideos();
        fetchShorts();
        fetchPlaylists();
    }, []);

    const fetchVideos = async (pageToken = '') => {
        try {
            // Fetch playlist details
            const { data: playlistData } = await axios.get(
                `https://www.googleapis.com/youtube/v3/channels?part=contentDetails&id=${CHANNEL_ID}&key=${API_KEY}`
            );

            const uploadsPlaylistId = playlistData.items[0].contentDetails.relatedPlaylists.uploads;

            // Fetch videos in the playlist with 3 results per request
            const { data: videosData } = await axios.get(
                `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${uploadsPlaylistId}&key=${API_KEY}&maxResults=3&pageToken=${pageToken}`
            );

            // Update state with fetched videos
            setVideos(prevVideos => [...prevVideos, ...videosData.items]);
            setVideoPageToken(videosData.nextPageToken); // Set the next page token for future fetches
        } catch (error) {
            console.error("Error fetching videos:", error);
        }
    };


    const fetchShorts = async (pageToken = '') => {
        try {
            const { data: shortsData } = await axios.get(
                `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${CHANNEL_ID}&type=video&videoDuration=short&key=${API_KEY}&maxResults=3&pageToken=${pageToken}`
            );

            setShorts(prevShorts => [...prevShorts, ...shortsData.items]);
            setShortsPageToken(shortsData.nextPageToken); // Set the next page token for future fetches
        } catch (error) {
            console.error("Error fetching shorts:", error);
        }
    };

    const fetchPlaylists = async () => {
        let allPlaylists = [];
        let nextPageToken = '';

        try {
            do {
                const { data: playlistsData } = await axios.get(
                    `https://www.googleapis.com/youtube/v3/playlists?part=snippet,contentDetails&channelId=${CHANNEL_ID}&key=${API_KEY}&maxResults=50&pageToken=${nextPageToken}`
                );

                allPlaylists = [...allPlaylists, ...playlistsData.items];
                nextPageToken = playlistsData.nextPageToken;
            } while (nextPageToken);

            setPlaylists(allPlaylists);
        } catch (error) {
            console.error("Error fetching playlists:", error);
        }
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    useEffect(() => {
        // Simulate loading time
        const timer = setTimeout(() => {
            setLoading(false); // Set loading to false after content is loaded
        }, 1500); // Adjust time as needed

        return () => clearTimeout(timer); // Cleanup the timer on unmount
    }, []);
    return (
        <>
            {/* Loader */}
            {loading && <div className="loader-container">
                <div className="loader"></div>
                <img src="/images/logo192.png" alt="Anuyog Icon" className="loader-icon" />
            </div>}


            {!loading && (
                <>
                    {/* Banner and social section */}
                    <section className="vidio-banner-section">
                        <div className="vidio-banner">
                            <img src={vid} alt="" />
                            <h1 className="consultancy-heading">
                                Develop a true understanding of a balanced, <br /> natural lifestyle through expert-reviewed content
                            </h1>

                        </div>
                    </section>

                    {/* Social media links */}
                    <section className="head-section section-gapping">
                        <div className="container">
                            <h1 className="mb-5"><strong>The Anuyog Institute</strong></h1>
                            <div className="head">
                                <div className="head-detail">
                                    <div className="head-logo">
                                        <img src={logo} alt="" />
                                    </div>
                                    <div className="head-text">
                                        <h3>Subscribe on your favorite platform</h3>
                                        <ul className={styles.socialList}>
                                            <a href="https://www.youtube.com/@theanuyoginstitute"><li className={`${styles.socialItem} ${styles.footerListItem}`}><img src={youtube} className={styles.socialIcon} alt="" /></li></a>
                                            <a href="https://www.facebook.com/theanuyoginstitute/"><li className={`${styles.socialItem} ${styles.footerListItem}`}><img src={fb} className={styles.socialIcon} alt="" /></li></a>
                                            <a href="https://www.instagram.com/theanuyoginstitute/"><li className={`${styles.socialItem} ${styles.footerListItem}`}><img src={ig} className={styles.socialIcon} alt="" /></li></a>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Tabs Section */}
                    <section className="tabs-section section-gapping">
                        <div className="container">
                            <div className="tabs">
                                <button className={activeTab === 'home' ? 'active' : ''} onClick={() => handleTabClick('home')}>Home</button>
                                <button className={activeTab === 'videos' ? 'active' : ''} onClick={() => handleTabClick('videos')}>Videos</button>
                                <button className={activeTab === 'shorts' ? 'active' : ''} onClick={() => handleTabClick('shorts')}>Shorts</button>
                                <button className={activeTab === 'playlists' ? 'active' : ''} onClick={() => handleTabClick('playlists')}>Playlists</button>
                            </div>
                        </div>
                    </section>

                    {/* Content Section */}
                    <section className={activeTab === 'home' ? 'home-section section-gapping' :
                        activeTab === 'videos' ? 'videos-section section-gapping' :
                            activeTab === 'shorts' ? 'shorts-section section-gapping' :
                                activeTab === 'playlists' ? 'playlists-section section-gapping' : ''}>
                        <div className="container">
                            {activeTab === 'home' ? (
                                <>
                                    <h1 className="mb-5 offering-title">All Videos from The Anuyog Institute</h1>
                                    <InfiniteScroll
  dataLength={videos.length + shorts.length}
  next={() => fetchVideos(videoPageToken)}
  hasMore={!!videoPageToken}
  loader={
    <div className="videos-grid">
      {[...Array(3)].map((_, idx) => (
        <div key={idx} className="video-item skeleton-thumbnail mb-4" />
      ))}
    </div>
  }
>
  <div className="videos-grid">
    {[...videos, ...shorts].map((item, index) => (
      <VideoItem item={item} key={index} />
    ))}
  </div>
</InfiniteScroll>

                                </>
                            ) : activeTab === 'videos' ? (
                                <>
                                    <h1 className="mb-5">Videos from The Anuyog Institute</h1>
                                    <InfiniteScroll
                                        dataLength={videos.length}
                                        next={() => fetchVideos(videoPageToken)}
                                        hasMore={!!videoPageToken}
                                        loader={<h4>Loading...</h4>}
                                    >
                                        <div className="videos-grid">
                                            {videos.map(video => (
                                                <div className="video-item" key={video.id}>
                                                    <div className="drope-image">
                                                        <iframe
                                                            width="100%"
                                                            height="315"
                                                            src={`https://www.youtube.com/embed/${video.snippet.resourceId.videoId}`}
                                                            title="YouTube video player"
                                                            frameBorder="0"
                                                            loading="lazy"
                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                            referrerPolicy="strict-origin-when-cross-origin"
                                                            allowFullScreen
                                                        ></iframe>
                                                    </div>
                                                    <div className="drope-text vidio-custom">
                                                        <h3>{video.snippet.title}</h3>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </InfiniteScroll>
                                </>
                            ) : activeTab === 'shorts' ? (
                                <>
                                    <h1 className="mb-5">Shorts</h1>
                                    <InfiniteScroll
                                        dataLength={shorts.length}
                                        next={() => fetchShorts(shortsPageToken)}
                                        hasMore={!!shortsPageToken}
                                        loader={<h4>Loading...</h4>}
                                    >
                                        <div className="videos-grid">
                                            {shorts.map(short => (
                                                <div className="video-item" key={short.id}>
                                                    <div className="drope-image">
                                                        <iframe
                                                            width="100%"
                                                            height="315"
                                                            src={`https://www.youtube.com/embed/${short.id.videoId}`}
                                                            title="YouTube video player"
                                                            frameBorder="0"
                                                            loading="lazy"
                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                            referrerPolicy="strict-origin-when-cross-origin"
                                                            allowFullScreen
                                                        ></iframe>
                                                    </div>
                                                    <div className="drope-text vidio-custom">
                                                        <h3>{short.snippet.title}</h3>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </InfiniteScroll>
                                </>
                            ) : activeTab === 'playlists' ? (
                                <>
                                    <h1 className='mb-5'>Playlists from The Anuyog Institute</h1>
                                    <div className="videos-grid">
                                        {playlists.map((playlist) => (
                                            <div className="video-item" key={playlist.id}
                                                 style={{position: "relative"}}>
                                                <a
                                                    href={`https://www.youtube.com/playlist?list=${playlist.id}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{textDecoration: "none", color: "inherit"}}
                                                >
                                                    <div className="drope-image" style={{position: "relative"}}>
                                                        <img
                                                            src={playlist.snippet.thumbnails.medium.url}
                                                            alt={playlist.snippet.title}
                                                            style={{
                                                                width: "100%",
                                                                height: "auto",
                                                                borderRadius: "8px",
                                                                display: "block",
                                                            }}
                                                        />

                                                        <div
                                                            className={videoStyle.badge}
                                                        >
                                                            📺 {playlist.contentDetails.itemCount} {playlist.contentDetails.itemCount > 1 ? "videos" : "video"}
                                                        </div>
                                                    </div>

                                                    <div className="drope-text vidio-custom">
                                                        <h3>{playlist.snippet.title}</h3>
                                                    </div>
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </section>
                </>
            )}
        </>
    );
}

export default Video;
